/*
 *  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  * No part of this publication may be reproduced, distributed,
 *  * or transmitted in any form or by any means, including photocopying, recording,
 *  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  * except in the case of brief quotations embodied in critical
 *  * reviews and certain other noncommercial uses permitted by copyright law.
 *  *  author : BS
 *  *  date : 1/25/23, 12:04 PM
 */

import { BehaviorSubject } from 'rxjs';
import { Entity } from '../../model/entity/entity';
import { DataTab } from '../../model/tabs/data-tab';
import { TabManager } from './tab-manager';

/**
 * @Deprecated :: Use TabManager<T extends Tab> instead
 */
export class DataTabManager<T extends Entity> extends TabManager {
  public override tabs: DataTab<T>[] = [];

  protected override activeTab$$ = new BehaviorSubject<DataTab<T> | null>(null);
  public override readonly activeTab$ = this.activeTab$$.asObservable();
  public override get activeTab(): DataTab<T> | null {
    return this.activeTab$$.getValue();
  }
}
